import List from "@/components/list";

const Table = args => {
  const { listeners } = args;
  const RCSelectionChange = listeners["selection-change"] || function() {};
  const audit = listeners["audit"] || function() {};
  const detail = listeners["detail"] || function() {};

  function selectable(row, index) {
    if (row.auditStatus == 0 && row.isAudit) {
      return true
    }
    return false
  }

  const Deal = ({ props: { vo } }) => {
    let dealConf = [];
    if (vo.row.auditStatus != 0 || !vo.row.isAudit) {
      dealConf.push([
        "icon-steps",
        "查看审核详情",
        () => {
          detail(vo.row);
        },
        "userAdd:audit:list"
      ]);
    } else {
      dealConf.push([
        "icon-audit",
        "审核",
        () => {
          audit(vo.row);
        },
        "userAdd:audit:update"
      ]);
    }
    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const tableConfig = [
    {
      type: "selection",
      label: "main",
      selectable: selectable
    },
    {
      label: "姓名",
      prop: "userName",
      minWidth: "80",
      showOverflowTooltip: true
    },
    {
      label: "账号",
      prop: "userMobile",
      minWidth: "100"
    },
    {
      label: "学院",
      prop: "parentDeptName",
      minWidth: "100"
    },
    {
      label: "单位",
      prop: "deptName",
      minWidth: "100",
      showOverflowTooltip: true
    },
    {
      label: "单位及职务",
      prop: "unitPosition",
      minWidth: "220",
      showOverflowTooltip: true
    },
    {
      label: "添加人",
      prop: "createUserName",
      minWidth: "100",
      showOverflowTooltip: true
    },
    {
      label: "添加人手机号",
      prop: "createUserMobile",
      minWidth: "100"
    },
    {
      label: "添加时间",
      prop: "createDate",
      minWidth: "140"
    },
    {
      label: "审核状态",
      prop: "auditStatusName",
      minWidth: "100"
    },
    {
      label: "操作",
      minWidth: "80",
      fixed: "right",
      render: vo => <Deal vo={vo} />
    }
  ];
  return <List {...args}
               onSelectionChange={RCSelectionChange}
               talbeCols={tableConfig} />;
};

export default Table;
